module.exports = __webpack_public_path__ + "img/rgb_Ai_61.jpg";